const Header = ({ domainName }) => {
  return (
    <header className="header">
      <h2>{domainName}</h2>
    </header>
  );
};

export default Header;